export default {
  // 主题色
  colorTheme: '#06b86b',

  // 主题背景色
  colorThemeBg: '#f0fbf6'
}
